export default __webpack_public_path__ + "static/stiftungs-logo-zweizeilig-486c062c851e5568c13a9e5c4d90786d.png";